// We should be using sizing from this
// Should these be updated to better match with our Mantine breakpoints?
export const screenBreakPoints = [
  { screen: 'desktop', max: 10000, min: 1280 },
  { screen: 'desktop', max: 1279, min: 1024 },
  { screen: 'tablet', max: 1023, min: 431 },
  { screen: 'mobile', max: 430, min: 0 },
];
